import { EntityRefBasePicker } from '@agilelab/plugin-wb-platform';
import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/lib/useAsync';

const ALLOWED_KINDS = ['user', 'group'];

const fromEntityToString = (entity: Entity) => {
  return `${entity.kind.toLowerCase()}:${entity.metadata.namespace}/${
    entity.metadata.name
  }`;
};

type WbUsersAndGroupsPickerProps = {
  value: string[];
  onChange: (val: string[]) => void;
  disabled?: boolean;
  checkOptionDisabled?: ((option: string) => boolean) | undefined;
  disabledKind?: 'user' | 'group';
  maxItems?: number;
  required?: boolean;
};

export const WbUsersAndGroupsPicker = ({
  value,
  onChange,
  disabled,
  checkOptionDisabled,
  disabledKind,
  maxItems,
  required,
}: WbUsersAndGroupsPickerProps) => {
  const catalogApi = useApi(catalogApiRef);

  let title;
  if (disabledKind === undefined) {
    title = 'Users and Groups';
  } else if (disabledKind === 'user') {
    title = 'Groups';
  } else {
    title = 'Users';
  }

  let helperText;
  if (disabledKind === undefined) {
    helperText = 'Start typing to search for a user or a group';
  } else if (disabledKind === 'user') {
    helperText = 'Start typing to search for a group';
  } else {
    helperText = 'Start typing to search for a user';
  }

  const { value: identities } = useAsync(async () => {
    const filter = { kind: ALLOWED_KINDS.filter(k => k !== disabledKind) };

    return (await catalogApi.getEntities({ filter })).items.map(
      fromEntityToString,
    );
  }, [catalogApi, disabledKind]);

  return (
    <EntityRefBasePicker
      checkOptionDisabled={checkOptionDisabled}
      disabled={disabled}
      options={identities ?? []}
      prefillValues={value ?? []}
      onChange={onChange}
      title={title}
      helperText={helperText}
      style={{ width: '100%' }}
      maxItems={maxItems}
      required={required}
    />
  );
};
